import axios from 'axios'
import { axiosConfig } from '../config/axiosConfig.js'

export function logout_ajax(client_name) {
    return axios.get('logout/', axiosConfig)
        .then(function () {
            location.reload();
        }.bind(this))
        .catch(function (error) {
            console.log(error);
        })

}

export function check_logged_state_ajax() {
    return axios.post('cls/', {}, axiosConfig)
        .then(function (res) {
            if (!(res.data instanceof Object)) {
                res.data = JSON.parse(res.data);
            }                 

            const res_data = res['data'];
            this.$store.dispatch('set_username', res_data['name']);
        }.bind(this))
        .catch(function (error) {
            console.log(error);
        })

}

export async function get_user_customization (client_name) {
    const response = await axios.post(`${client_name}/rainmonitor/get_user_customization/`, {}, axiosConfig);
    try {
        const result = typeof response.data === 'object' ? response.data : JSON.parse(response.data);
        return result;

    } catch (error) {
        console.error(error);
    }
}